import CanvasHandler from "./CanvasHandler";
import { Seat } from "../canvas/preview";
import { IObjectPreview } from "../types/HandlerObjectType";
import BaseObjectHandler from "./BaseObjectHandler";

class PreviewHandler extends BaseObjectHandler<IObjectPreview> {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
    this.objectTypes = {
      seat: new Seat(canvasHandler),
    };
  }
}

export default PreviewHandler;
